import './SellerDatev.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DownloadIcon } from '../../../icons/download.svg';
import { downloadFile, formatDate } from '../../../core/helpers';
import { useTaxAdvisor } from '../../TaxAdvisor/tax-advisor-context';
import Tabs from '../../../components/Tabs/Tabs';
import Button from '../../../components/Button';

interface DatevFile {
  name: string;
  href: string;
}

interface DatevItem {
  date: Date;
  files: DatevFile[];
}

interface Props {
  page?: boolean;
}

const TABS = [2022, 2021];

export default function SellerDatev({ page = true }: Props) {
  const { company } = useTaxAdvisor();
  const { t } = useTranslation();

  const renderContent = () => (
    <>
      {DATA.map((d) => (
        <div key={d.date.getMonth()} className='mb-3'>
          <div className='fw-600 mb-2'>{formatDate(d.date, 'MMMM')}</div>
          <div className='row row-cols-auto gx-2 mt-n1'>
            {d.files.map((f) => (
              <div className='col py-1' key={f.name}>
                <Button
                  styling='outline'
                  className='py-2 ps-2 pe-3 d-inline-flex align-items-center'
                  onClick={() => {
                    downloadFile(
                      f.href,
                      `${
                        company?.name
                          ? `${company.name.split(' ').join('_')}-`
                          : ''
                      }${formatDate(d.date, 'MMM-yyyy')}-${f.name}`
                    );
                  }}
                >
                  <DownloadIcon className='SellerManualUploadInstructionBlock__download me-2' />
                  {f.name}
                </Button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );

  if (page) {
    return (
      <div className='Page flex-grow-1'>
        <div className='container'>
          <div className='Paper p-4 Paper--sm mx-auto'>
            <div className='Text--30 fw-900 mb-4'>{t('DATEV files')}</div>
            <Tabs tabs={TABS} renderContent={renderContent} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className='mb-1'>{TABS[0]}</div>
      {renderContent()}
    </>
  );
}

const DATA: DatevItem[] = [
  {
    date: new Date(2022, 8, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 7, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 6, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 5, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 4, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 3, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
      {
        name: 'OSS_netto.csv',
        href: '/datev/OSS_netto.csv',
      },
      {
        name: 'OSS_vat.csv',
        href: '/datev/OSS_vat.csv',
      },
    ],
  },
  {
    date: new Date(2022, 2, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
    ],
  },
  {
    date: new Date(2022, 1, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
    ],
  },
  {
    date: new Date(2022, 0, 1),
    files: [
      {
        name: 'Local.csv',
        href: '/datev/Local.csv',
      },
      {
        name: 'Warenverbringugen.csv',
        href: '/datev/Warenverbringungen.csv',
      },
      {
        name: 'Commingling.csv',
        href: '/datev/Commingling.csv',
      },
    ],
  },
];
